// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"8b11a06e","453":"f69915c6","490":"f0a19b1b"}[chunkId] + ".chunk.js";
};